import React from "react";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import SortByAlphaIcon from "@material-ui/icons/SortByAlpha";
import FavoriteIcon from "@material-ui/icons/Favorite";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import AccountCircle from "@material-ui/icons/AccountCircle";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import Avatar from "@material-ui/core/Avatar";

import { Link, navigate } from "@reach/router";

import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import { fade, makeStyles } from "@material-ui/core/styles";

import SearchIcon from "@material-ui/icons/Search";
import CssBaseline from "@material-ui/core/CssBaseline";
import { styled } from "@material-ui/core/styles";
import ConfigDialog from "./config.js";

const appBarUseStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1,
    fontSize: "28pt",
    paddingRight: "6px",
    [theme.breakpoints.up("sm")]: {
      display: "block"
    }
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto"
    }
  },
  loginButton: {
    paddingRight: "0px"
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  inputRoot: {
    color: "inherit"
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch"
      }
    }
  }
}));

export function LoginDialog(props) {
  const firebase = props.firebase;
  const uiConfig = {
    callbacks: {
      signInSuccessWithAuthResult: function (authResult, redirectUrl) {
        // User successfully signed in.
        // Return type determines whether we continue the redirect automatically
        // or whether we leave that to developer to handle.
        firebase.analytics().logEvent("login_success");
        props.onLogin();
        return true;
      }
    },
    // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
    signInFlow: "popup",
    signInSuccessUrl: "/",
    signInOptions: [
      // Leave the lines as is for the providers you want to offer your users.
      firebase.auth.GoogleAuthProvider.PROVIDER_ID
      //    firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      //    firebase.auth.TwitterAuthProvider.PROVIDER_ID,
      //    firebase.auth.GithubAuthProvider.PROVIDER_ID,
      //    firebase.auth.EmailAuthProvider.PROVIDER_ID,
      //    firebase.auth.PhoneAuthProvider.PROVIDER_ID
    ],
    // Terms of service url.
    tosUrl: "<your-tos-url>",
    // Privacy policy url.
    privacyPolicyUrl: "<your-privacy-policy-url>"
  };
  firebase.analytics().setCurrentScreen("login");
  return (
    <Dialog aria-labelledby="simple-dialog-title" open={props.open}>
      <DialogTitle id="simple-dialog-title">Bienvenide</DialogTitle>
      <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
    </Dialog>
  );
}
export function ButtonAppBar(props) {
  const classes = appBarUseStyles();
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [configOpen, setConfigOpen] = React.useState(false);
  const firebase = props.firebase;
  const user = props.user;
  const updateConfig = props.updateConfig;

  const handleMenu = event => {
    if (firebase.auth().currentUser === null) {
      setDialogOpen(true);
    } else {
      setConfigOpen(true);
    }
  };

  const handleConfigClose = () => {
    console.warn("setconfig close");
    setConfigOpen(false);
  };

  let otherUserName;
  if (props.otherUser) {
    otherUserName = " > " + props.otherUser.name;
  } else {
    otherUserName = "";
  }

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <div>
            <Typography className={classes.title} variant="h6" noWrap>
              <Link to="/" style={{ textDecoration: "none" }}>
                <span role="img" aria-label="pig nose logo">
                  🐽
                </span>
              </Link>
              {otherUserName}
            </Typography>
          </div>
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder="Buscar…"
              value={props.query}
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput
              }}
              inputProps={{ "aria-label": "search" }}
              onChange={props.handleSearch}
            />
          </div>
          <div>
            <IconButton
              className={classes.loginButton}
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              {user ? (
                <Avatar src={firebase.auth().currentUser.photoURL} />
              ) : (
                <AccountCircle />
              )}
            </IconButton>
            <LoginDialog
              open={dialogOpen}
              firebase={firebase}
              onLogin={props.onLogin}
            />
            <ConfigDialog
              open={configOpen}
              handleClose={handleConfigClose}
              user={user}
              updateConfig={updateConfig}
            />
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}

const bottomNavUseStyles = makeStyles({
  root: {
    width: "100%",
    position: "fixed",
    bottom: 0
  }
});
export function CYTBottomNavigation(props) {
  const classes = bottomNavUseStyles();

  return (
    <BottomNavigation className={classes.root}>
      <BottomNavigationAction
        label="A-Z"
        onClick={props.sortByAlpha}
        icon={<SortByAlphaIcon />}
      />
      <BottomNavigationAction
        label="Favoritos"
        onClick={props.onlyFavorites}
        icon={<FavoriteIcon />}
      />
      <BottomNavigationAction
        label="Cercanía"
        onClick={props.sortByDistance}
        icon={<LocationOnIcon />}
      />
    </BottomNavigation>
  );
}
function Div(props) {
  return <div style={{ height: "70vh" }}>{props.children}</div>;
}

const MyDiv = styled(Div)({
  root: {
    flexGrow: 1,
    height: "100vh",
    border: "1px solid red"
  }
});

export function Layout(props) {
  const firebase = props.firebase;
  const user = props.user;

  console.log("Layout", props);
  return (
    <MyDiv>
      <CssBaseline />
      <ButtonAppBar
        firebase={firebase}
        query={props.query}
        handleSearch={props.handleSearch}
        user={user}
        otherUser={props.otherUser}
        onLogin={props.onLogin}
        updateConfig={props.updateConfig}
      />
      {props.children}
    </MyDiv>
  );
}
export function navigateToState(nextState) {
  let url;
  url = "/";
  if (nextState.categories && nextState.categories.length > 0) {
    url = `/c/${nextState.categories.sort().join(",")}`;
  }
  if (nextState.query) {
    url += `?q=${encodeURIComponent(nextState.query)}`;
  }
  console.log("Navigating to: ", url);
  if (url) {
    navigate(url);
  }
}
